import { InputRef } from "antd"
import { useRef } from "react"

export const useDrawerFocus = (open: boolean) => {
    const focusRef = useRef<InputRef>(null)
    const afterOpenChange = () => {
        if (open && focusRef?.current) {
            focusRef.current?.focus()
        }
    }
    return { focusRef, afterOpenChange }
}
